// import axios from "axios";
// console.log(sessionStorage.getItem("branch"));
// const baseURLFromLocalStorage =
//   sessionStorage.getItem("branch") === "branch1"
//     ? "https://diner.smartvillageqatar.com/"
//     : "https://dinersecond.smartvillageqatar.com/";

// export default axios.create({
//   baseURL: baseURLFromLocalStorage,
// });


import axios from "axios";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  config.baseURL =
    sessionStorage.getItem("branch") === "branch1"
    ? process.env.REACT_APP_BRANCH_1
    : process.env.REACT_APP_BRANCH_2;
  return config;
});

export default axiosInstance;